import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { getTsdResourceListData } from './mockData'
import type { ITsdResource } from '~/types/tsd/models'

interface GetTsdResourcesResponse {
  data: ITsdResource[]
}

async function getTsdResources(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetTsdResourcesResponse = {
    data: await getTsdResourceListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postTsdResource = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getTsdResourceListData)
}

const patchTsdResource = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getTsdResourceListData)
}

const deleteTsdResource = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getTsdResourceListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/tsdresources',
    handler: getTsdResources,
  },
  {
    method: 'post',
    path: '/api/tsdresources',
    handler: postTsdResource,
  },
  {
    method: 'patch',
    path: '/api/tsdresources/:id',
    handler: patchTsdResource,
  },
  {
    method: 'delete',
    path: '/api/tsdresources/:id',
    handler: deleteTsdResource,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
